import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Seo from '../../../components/Seo/Seo';
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import './PageLayout.scss';
import FavIcon from '../../assets/images/favicon.ico';
import defaultImage from '../../assets/images/generic-preview.png';

import Header from './Header/Header';
import Main from './Main/Main';
import Footer from './Footer/Footer';

import Sidebar from '../Sidebar/Sidebar';

const PageLayout = ({
  children,
  page,
  description,
  image,
  language,
  changeLanguage,
  zipcode,
  activePage,
  userLocation,
  title,
  electricVehicles,
  usedElectricVehicles,
  pageID,
  useMain = true,
}) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="PageLayout" id={pageID}>
      <Helmet defer={true}>
        <link rel="shortcut icon" href={FavIcon} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
      </Helmet>
      <Seo
        image={image ? image : defaultImage}
        title={title}
        path={location.pathname}
        description={description}
        twitterHandle={
          process.env.REACT_APP_COMPONENTS_SEO_TWITTER_HANDLE
            ? process.env.REACT_APP_COMPONENTS_SEO_TWITTER_HANDLE
            : null
        }
      />
      {process.env.REACT_APP_LEAD_GEN && (
        <Sidebar
          electricVehicles={electricVehicles}
          usedElectricVehicles={usedElectricVehicles}
        />
      )}

      <Header
        page={page}
        zipcode={zipcode}
        activePage={activePage}
        userLocation={userLocation}
        changeLanguage={changeLanguage}
        language={language}
      />
      {useMain ? (
        <Main>
          <span id="main-content-id" tabIndex="-1" />
          {children}
        </Main>
      ) : (
        <div className="Main">
          <span id="main-content-id" tabIndex="-1" />
          {children}
        </div>
      )}
      <Footer language={language} changeLanguage={changeLanguage} />
    </div>
  );
};

export default PageLayout;

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  props: PropTypes.object,
  page: PropTypes.string,
  image: PropTypes.string,
  description: PropTypes.string,
};
